import { render, staticRenderFns } from "./queryCommPjDetail.vue?vue&type=template&id=a9ef7b34&scoped=true&"
import script from "./queryCommPjDetail.vue?vue&type=script&lang=js&"
export * from "./queryCommPjDetail.vue?vue&type=script&lang=js&"
import style0 from "./queryCommPjDetail.vue?vue&type=style&index=0&id=a9ef7b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef7b34",
  null
  
)

export default component.exports